import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { OrderDetailsLineCollectionModel, OrderDetailsParams } from "@tKgpco/Services/GetOrderLineDetailsService";
import { LoadOrderLinesDetailState } from "@tKgpco/Store/Data/OrderHistoryDetail/LoadOrderLineDetailsState";
import { Draft } from "immer";

const initialState: LoadOrderLinesDetailState = {
    isLoading: {},
    collection: [],
};

const reducer = {
    "Custom/Orders/BeginLoadOrderDetailsLine": (
        draft: Draft<LoadOrderLinesDetailState>,
        action: { parameter: OrderDetailsParams },
    ) => {
        if (action.parameter.pageNumber !== undefined) {
            draft.isLoading[action.parameter.pageNumber] = true;
        }
    },
    "Custom/Orders/CompleteLoadOrderDetailsLine": (
        draft: Draft<LoadOrderLinesDetailState>,
        action: { parameter: OrderDetailsParams; collection: OrderDetailsLineCollectionModel[] },
    ) => {
        if (action.parameter.pageNumber !== undefined) {
            draft.isLoading[action.parameter.pageNumber] = false;
        }
        draft.collection = [...draft.collection, ...action.collection];
    },
    "Custom/Orders/ResetLoadOrderDetailsLine": (
        draft: Draft<LoadOrderLinesDetailState>
    ) => {
        draft.isLoading = {};
        draft.collection = [];
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
